module.exports = __webpack_public_path__ + "static/media/RSR.1652e89d.svg";